<!-- Copyright 2021 Rennie Glen Software LLC -->
<template>
  <div class="cookie-notice" v-if="showCookieNotice">
    <div>
      <p class="text">
        <i18n-t scope=global keypath="cookieNotice.privacyLink">
          <template v-slot:link>
            <router-link to="/privacy">{{ $t('titles.privacyPolicy') }}</router-link>
          </template>
        </i18n-t>        
      </p>
      <div class="button-row">
        <a href="" @click.prevent="onClickOk" class="likeabutton okbutton">{{ $t('cookieNotice.okButton') }}</a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref } from 'vue';

export const showCookieNotice = ref(false);
</script>

<script setup lang="ts">
import { onMounted } from 'vue';

const gdprUrl = "https://adservice.google.com/getconfig/pubvendors"
const gdprOk = "GDPROK"

onMounted(async (): Promise<void> => {
  if (!window.localStorage.getItem(gdprOk)) {
    // User hasn't agreed to GDPR yet.
    // Are they in europe?
    let inEurope = true;
    try {
        const response = await fetch(gdprUrl);
        const json = await response.json();
        if (false === json.is_request_in_eea_or_unknown) {
            inEurope = false;
        }
    } catch (err) {
        console.log(err);
    }
    if (inEurope) {
        showCookieNotice.value = true;
    }
  }
});

function onClickOk(): void {
  showCookieNotice.value = false;
  window.localStorage.setItem(gdprOk, "Ja");
}

</script>

<style scoped>
.cookie-notice {
  background: black;
  color: white;
  font-weight: bold;
  border-width: 2px;
  bottom: 0;
  left: 0;
  right: 0;
  height: 8em;
  opacity: 0.9;
  overflow-y: scroll;
  padding: 1em;
  position: fixed;
  z-index: 22;
  display: flex;
  justify-content: center;
}

.okbutton {
  min-width: 200px;
}

.text a {
  color: white;
}
</style>